module.exports = __webpack_public_path__ + "static/media/profile-add.132a3bcd.svg";